import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    margin: 1rem 0 0 1rem;

    font-size: 0.8rem;
`